// store/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const PortfolioInvestmentSlice = createSlice({
  name: "portfolio",
  initialState: {
    portfolioInvestmentId:localStorage.getItem("portfolioInvestmentId") || null,
  },
  reducers: {
    setPortfolioInvestmentId: (state, action) => {
      localStorage.setItem("portfolioInvestmentId", action.payload);
      state.portfolioInvestmentId = action.payload;
    },
    clearPortfolioInvestmentId: (state) => {
      localStorage.removeItem("portfolioInvestmentId");
      state.portfolioInvestmentId = null;
    },
  },
});

export const { setPortfolioInvestmentId, clearPortfolioInvestmentId } = PortfolioInvestmentSlice.actions;
export default PortfolioInvestmentSlice.reducer;
